import { axiosInstance } from 'shared/config/axios';
import {
	GetGenerativeModelsRequest,
	CreateGeneratoveModelRequest,
	UpdateGeneratoveModelRequest,
	PostGeneratoveModelFileRequest,
	GetGenerativeFilesRequest,
	DeleteGeneratoveModelFileRequest,
	DeleteGeneratoveModelRequest,
	GetGenerativeFileDetailsRequest,
	PutGenerativeLabelsRequest,
} from 'entities/generative-models/api/types';

export const getGenerativeModels: GetGenerativeModelsRequest = (queries) => {
	return axiosInstance.get('/generative-models', { params: { ...queries } });
};

export const postGenerativeModel: CreateGeneratoveModelRequest = (data) => {
	return axiosInstance.post('/generative-models', data);
};

export const patchGenerativeModel: UpdateGeneratoveModelRequest = ({ generativeModelId, data }) => {
	return axiosInstance.patch(`/generative-models/${generativeModelId}`, data);
};

export const deleteGenerativeModel: DeleteGeneratoveModelRequest = ({ generativeModelId }) => {
	return axiosInstance.delete(`/generative-models/${generativeModelId}`);
};

export const getGenerativeModelFilesList: GetGenerativeFilesRequest = ({ generativeModelId }) => {
	return axiosInstance.get(`/generative-models/${generativeModelId}/files`);
};

export const postGenerativeModelFile: PostGeneratoveModelFileRequest = ({ generativeModelId, data }) => {
	return axiosInstance.post(`/generative-models/${generativeModelId}/direct-uploading`, data, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const deleteGenerativeModelFile: DeleteGeneratoveModelFileRequest = (data) => {
	return axiosInstance.delete('/generative-models/delete-files', { data });
};

export const getGenerativeFileDetails: GetGenerativeFileDetailsRequest = ({ generativeModelFileId }) => {
	return axiosInstance.get(`/generative-models/file-labels/${generativeModelFileId}`);
};

export const putGenerativeLabels: PutGenerativeLabelsRequest = ({ generativeModelFileId, data }) => {
	return axiosInstance.put(`/generative-models/file-labels/${generativeModelFileId}`, data);
};
